/**
 * L6.3a — React context shape for localization.
 *
 * Context value is always a fully-resolved LocalizationProfile (never
 * partial, never null) so consumers can read `language`/`locale`/etc.
 * unconditionally. The provider does the resolution from possibly-null
 * input; consumers should not.
 *
 * See docs/LOCALIZATION-ARCHITECTURE.md §9.
 */
import { createContext } from 'react';
import { PLATFORM_DEFAULT_LOCALIZATION, } from '@roi-pros/core/localization';
const defaultValue = {
    localization: PLATFORM_DEFAULT_LOCALIZATION,
    language: PLATFORM_DEFAULT_LOCALIZATION.language,
    locale: PLATFORM_DEFAULT_LOCALIZATION.locale,
    region: PLATFORM_DEFAULT_LOCALIZATION.region,
    timezone: PLATFORM_DEFAULT_LOCALIZATION.timezone,
    currency: PLATFORM_DEFAULT_LOCALIZATION.currency,
    communicationLocalization: null,
};
export const LocalizationContext = createContext(defaultValue);
//# sourceMappingURL=LocalizationContext.js.map